const EDITABLE_SHORTCUT_TARGET_SELECTOR = [
    'input',
    'textarea',
    'select',
    '[contenteditable]:not([contenteditable="false"])',
    '[role="textbox"]',
    '[role="searchbox"]',
    '[role="combobox"]',
    '[role="spinbutton"]',
    '.ProseMirror',
    '.monaco-editor',
    '.cm-editor',
    '.CodeMirror',
].join(', ');

const isElement = (value: unknown): value is Element => {
    return typeof Element !== 'undefined' && value instanceof Element;
};

const isEditableElement = (element: Element): boolean => {
    if (element instanceof HTMLElement && element.isContentEditable) {
        return true;
    }

    return element.matches(EDITABLE_SHORTCUT_TARGET_SELECTOR) || !!element.closest(EDITABLE_SHORTCUT_TARGET_SELECTOR);
};

export const isEditableKeyboardTarget = (target: EventTarget | null): boolean => {
    return isElement(target) && isEditableElement(target);
};

const getKeyboardEventTargets = (event: KeyboardEvent): Element[] => {
    const targets = event.composedPath().filter(isElement);

    if (targets.length > 0) {
        return targets;
    }

    if (isElement(event.target)) {
        return [event.target];
    }

    return typeof document !== 'undefined' && isElement(document.activeElement) ? [document.activeElement] : [];
};

export const shouldIgnorePlatformShortcut = (event: KeyboardEvent): boolean => {
    if (event.defaultPrevented || event.isComposing) {
        return true;
    }

    const targets = getKeyboardEventTargets(event);

    if (targets.some(isEditableElement)) {
        return true;
    }

    return typeof document !== 'undefined' && isEditableKeyboardTarget(document.activeElement);
};
